import React from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';

const ThresholdAlertModal = ({ isOpen, onClose, alert }) => {
  if (!alert || !alert.thresholdExceeded) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="">
      <div className="text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
          <svg className="h-6 w-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <h3 className="text-lg font-medium text-gray-900 mb-2">
          ALERT: RECOVER AMOUNT
        </h3>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
          <p className="text-sm text-gray-800">
            This debtor's outstanding amount ({alert.currentOutstanding?.toFixed(3)} BHD)
            has exceeded your threshold limit ({alert.thresholdAmount?.toFixed(3)} BHD).
          </p>
          <p className="text-sm font-semibold text-gray-900 mt-2">
            Please recover the amount from this debtor.
          </p>
        </div>

        <div className="flex gap-3 justify-center">
          <Button onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ThresholdAlertModal;
